import {
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  UNAUTHORIZED_USER,
  FORBIDDEN_ACTION,
} from "../types/authTypes";
import {
  DELETE_VALIDATIONS_ERROR,
  DELETE_VALIDATIONS_SUCCESS,
  GET_VALIDATIONS_ERROR,
  GET_VALIDATIONS_SUCCESS,
} from "../types/billTypes";
import {
  GENERATE_VALIDATION_ERROR,
  GENERATE_VALIDATION_SUCCESS,
  GET_FIELDS_ERROR,
  GET_FIELDS_SUCCESS,
  GET_VALIDATION_META_ERROR,
  GET_VALIDATION_META_SUCCESS,
  SAVE_VALIDATION_ERROR,
  SAVE_VALIDATION_SUCCESS,
  SET_VALIDATION_REDUCER,
} from "../types/validationTypes";

const initState = {
  validationFields: [],
  validationFieldFetchSuccess: false,
  validationFieldFetchError: false,
  validationMeta: [],
  validationMetaFetchSuccess: false,
  validationMetaFetchError: false,
  validationSaveSuccess: false,
  validationSaveError: false,
  genLogic: null,
  logicGenSuccess: false,
  logicGenError: false,
  validations: [],
  getValidationsSuccess: false,
  getValidationsError: false,
  deleteValidationSuccess: false,
  deleteValidationError: false,
};

const validationReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_FIELDS_SUCCESS:
      return {
        ...state,
        validationFields: action?.payload,
        validationFieldFetchSuccess: true,
        validationFieldFetchError: false,
      };
    case GET_FIELDS_ERROR:
      return {
        ...state,
        validationFields: [],
        validationFieldFetchSuccess: false,
        validationFieldFetchError: true,
      };

    case GET_VALIDATION_META_SUCCESS:
      return {
        ...state,
        validationMeta: action?.payload,
        validationMetaFetchSuccess: true,
        validationMetaFetchError: false,
      };
    case GET_VALIDATION_META_ERROR:
      return {
        ...state,
        validationMeta: {},
        validationMetaFetchSuccess: false,
        validationMetaFetchError: true,
      };

    case SAVE_VALIDATION_SUCCESS:
      return {
        ...state,
        validationSaveSuccess: true,
        validationSaveError: false,
      };
    case SAVE_VALIDATION_ERROR:
      return {
        ...state,
        validationSaveSuccess: false,
        validationSaveError: true,
      };

    case GENERATE_VALIDATION_SUCCESS:
      return {
        ...state,
        genLogic: action.payload,
        logicGenSuccess: true,
        logicGenError: false,
      };
    case GENERATE_VALIDATION_ERROR:
      return {
        ...state,
        genLogic: false,
        logicGenSuccess: false,
        logicGenError: true,
      };
    case GET_VALIDATIONS_SUCCESS:
      return {
        ...state,
        validations: action.payload,
        getValidationsSuccess: true,
        getValidationsError: false,
      };
    case GET_VALIDATIONS_ERROR:
      return {
        ...state,
        validations: [],
        getValidationsSuccess: false,
        getValidationsError: true,
      };
    case DELETE_VALIDATIONS_SUCCESS:
      return {
        ...state,
        deleteValidationSuccess: true,
        deleteValidationError: false,
      };
    case DELETE_VALIDATIONS_ERROR:
      return {
        ...state,
        deleteValidationSuccess: false,
        deleteValidationError: true,
      };

    case SET_VALIDATION_REDUCER:
      return {
        ...state,
        ...(action.payload || {}),
      };

    case LOGOUT_SUCCESS:
    case LOGOUT_ERROR:
    case UNAUTHORIZED_USER:
    case FORBIDDEN_ACTION:
      return initState;
    default:
      return state;
  }
};

export default validationReducer;
